import React from 'react'
import Layout from '../components/layoutBlog'
import { Link, graphql } from 'gatsby'
import { css } from "@emotion/core"
import { Disqus, CommentCount } from 'gatsby-plugin-disqus'
import { INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
//import Head from '../components/head'
import Metatags from '../components/metatag';

import projectStyles from '../styles/project.module.scss'
import blogStyles from '../styles/blog.module.scss'

export const query = graphql`

    query($slug: String!) {
        contentfulBlogPost(slug: {eq: $slug}) {
            titulo
            fechaPublicacion(formatString:"D MMMM, YYYY" locale: "es")
            slug
            descripcionCorta
            subtitulo
            autor
            imagenHero {
                fluid(maxWidth: 1000) {
                    src
                }
            }
            avatar {
                fluid(maxWidth: 100) {
                    src
                }
            }
            body {
                json
            }
        }
    }

`




const Blogpost = (props) => {


    const options = {
        renderNode: {
            "embedded-asset-block": (node) => {
                const alt = node.data.target.fields.title['es']
                const url = node.data.target.fields.file['es'].url
                return <img alt={alt} src={url} />
            },
            [INLINES.HYPERLINK]: (node) => {
                if(node.data.uri.indexOf('youtube.com') !== -1){
                    return(
                        <iframe width="560" height="315" src={node.data.uri} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    )
                }else{
                    return(
                    <a href={node.data.uri} target="_blank">{node.content[0].value}</a>
                    )
                }
            }
        }
    }

    let disqusConfig = {
        url: 'https://www.felixdigital.es/blog/' + `${props.data.contentfulBlogPost.slug}`,
        title: props.data.contentfulBlogPost.titulo,
    }
    
    const slugsite = props.data.contentfulBlogPost.slug

    return (
        <Layout>
            <Metatags
                title={`${props.data.contentfulBlogPost.titulo} | FelixDigital® `}
                description={props.data.contentfulBlogPost.descripcionCorta}
                pathname={slugsite}
                thumbnail={props.data.contentfulBlogPost.imagenHero.fluid.src}
            />
            <section className={blogStyles.header_wrapper}>

                <div className={blogStyles.post_header}>
                    <Link to={`/blog`} css={css`
                        color: #A58861;
                        text-decoration: none;
                        display: block;
                        text-align: left;
                    `}>Volver al blog</Link>
                </div>

                <div className={blogStyles.post_wrapper}>

                    <div className={blogStyles.post_wrapper_top}>

                        
                        <div className={blogStyles.post_wrapper_top_text}>

                            <h1 className={projectStyles.header_wrapper_box_text_main}>
                                {props.data.contentfulBlogPost.titulo}
                            </h1>

                            <p>{props.data.contentfulBlogPost.subtitulo}</p>

                        </div>
                        <div className={blogStyles.post_wrapper_top_image}>

                            <div className={blogStyles.post_wrapper_top_image_box} css={css`
                                background-image: url(${props.data.contentfulBlogPost.imagenHero.fluid.src});
                                background-repeat: no-repeat;
                                background-size: cover;
                                height: 100%;
                                border-radius: 20px;
                            `}></div>
                            
                            
                        </div>

                    </div>

                    <div className={blogStyles.post_wrapper_bottom}>
                        <div className={blogStyles.post_wrapper_bottom_avatar}>
                            <img src={props.data.contentfulBlogPost.avatar.fluid.src} alt={props.data.contentfulBlogPost.autor} />
                        </div>
                        <p><strong>{props.data.contentfulBlogPost.autor}</strong><br />{props.data.contentfulBlogPost.fechaPublicacion}</p>
                    </div>
                    
                </div>

            </section>

            <section className={blogStyles.main} id='post'>

                <div className={blogStyles.main_body}>
                    <div className={blogStyles.main_line}></div>
                    <div className={blogStyles.main_body_wrapper}>
                        {documentToReactComponents(props.data.contentfulBlogPost.body.json, options)}
                        <CommentCount config={disqusConfig} placeholder={'¿Alguna duda o pregunta?'} css={css`margin-top: 2rem;`}/>
                        <Disqus config={disqusConfig} css={css`width:100%;`} />
                    </div>
                </div>

            </section>
        </Layout>
    )

}

export default Blogpost